<template>
  <div>
    <h1>Welcome Jelly Go</h1>
  </div>
</template>

<script>


export default {
  name: 'HomeView',
  components: {
  }
}
</script>
